import Container from 'react-bootstrap/Container';
import Spinner from 'react-bootstrap/Spinner';
import { useEffect } from "react";
import { useState, useRef } from 'react';
import { useAuth } from '../lib/StAuthGiver.js';
import { callApi } from '../lib/Common_funcs.js';
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";

const WhichEnv = (process.env.REACT_APP_TURBO_ENV === undefined?'aws':'staging');
const Tdebug = (WhichEnv != 'aws');


export const StUpgradeSuccess = () => {

    const location = useLocation();
    const navigate = useNavigate();

    const [loading, setLoading] = useState(true);
    const {loginAction, logOut} = useAuth();
    const [udRefresh, setUdRefresh] = useState(false);
    const [error, setError] = useState('');

    // To prevent this from loading twice.
    const isMounted = useRef(false);
     
    if (process.env.NODE_ENV == 'development') {
        Tdebug &&  console.log("Node environment is development");
    }
    else {
        Tdebug &&  console.log("Node environment is " + process.env.NODE_ENV);
    }

    if (process.env.REACT_APP_TURBO_ENV === undefined) {
        Tdebug &&  console.log("running on aws")
    }
    else {
        Tdebug &&  console.log(process.env.REACT_APP_TURBO_ENV);
    }

    const getApiServer = () => {
        if (WhichEnv === 'aws') {
            return 'https://api-us.turbosteed.com';
        }
        else {
            return 'https://192.168.1.215:5000';
        }   
    }

    useEffect(() => {
        
        if (isMounted.current == false) {
            isMounted.current = true;
        }
        else {
            return;
        }

        const fetchData = async() => {

            const rcJson = await callApi('/ud', 'GET', {}, {});
            Tdebug && console.log(rcJson);

            if (rcJson.disposition == 'logout') {
                Tdebug && console.log("Now logging out");
                logOut();
            }

            if (rcJson.httpStatus != 200) {

                if (rcJson.disposition == 'retry') {
                    Tdebug && console.log(rcJson.message);
                    
                    // Handle retry.
                    setError('Upgrade failed, please contact support.');
                }
                else if (rcJson.disposition == 'abort') {
                    // Handle error.
                    Tdebug && console.log(rcJson.message);
                    setError('Upgrade failed, please contact support.');

                }

                // If the cookie has changed, update it.
                if (rcJson.respBody.etac) {
                    loginAction(null, rcJson.etac);
                }
                
                setError('Upgrade failed, please contact support.');
                
                setLoading(false);
            }
            else {

                // If the cookie has changed, update it.
                if (rcJson.respBody.etac) {
                    loginAction(null, rcJson.etac);
                }
                
                Tdebug && console.log("Setting values");


                setLoading(false);

                let curSiteIdx = 0;
                let sitesList = [];

                const responseJson = rcJson.respBody;

                for (var ss = 0; ss < responseJson.sites.length; ss++) {
                    sitesList.push(responseJson.sites[ss].siteId);
                }

                Tdebug && console.log(sitesList);

                localStorage.setItem("sites", JSON.stringify(responseJson.sites));
                localStorage.setItem("curSite", responseJson.sites[curSiteIdx].siteName);
                localStorage.setItem("curSiteIdx", curSiteIdx);

                navigate('/' + responseJson.sites[curSiteIdx].siteId + '/home', {replace: true});
            }
        }

        fetchData();
    
    
    }, []);



    if (loading == true) {

        return (
            <Container fluid className="min-vh-100 d-flex align-items-center justify-content-center dashboard-bg">
                <div className="text-center">
                    <Spinner animation="border" variant="primary" style={{ width: '2.5rem', height: '2.5rem' }} />
                    <div className="mt-3 text-dashboard-secondary dashboard-text-base">Upgrading your account...</div>
                </div>
            </Container>
        );
    }
    else if (error.length) {
        <div>
            <span className="page-title">Account Upgrade</span>
            <Container className="d-flex flex-column mx-2 px-2"> 
                {error}
            </Container>
        </div>
    }
    else {

        return (
            <div>
                
                <span className="page-title">Account Upgrade</span>

            </div>
                            
        );

    } // Loader is false.
}


export default StUpgradeSuccess;